module.exports = __webpack_public_path__ + "static/media/39.32248a75.mp4";